import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { translate } from 'react-i18next';

import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';
import { updateGoal, deleteGoal } from '../../user/duck';
import Modal from '../../common/Modal';
import Create from '../../memos/Create';
import { requestDataIfNeeded as requestUserGoalMemos } from '../memos/duck';

import Form from '../create/Form';
const ReduxForm = reduxForm()(Form);

class Edit extends React.Component {
  state = {
    shareMemoModalOpen: false,
  };

  handleShareMemoModalOpen = () => {
    this.setState({ shareMemoModalOpen: true });
  };
  handleShareMemoModalClose = () => {
    this.setState({ shareMemoModalOpen: false });
  };

  constructor(props) {
    super(props);

    const { disabled } = this.props;
    this.state = {
      disabled,
      shouldDisplayMenu: true,
    };
  }
  handleSubmit = (formValues) => {
    const { onSuccess, goal } = this.props;

    return API.put(`goals/${goal._id}`, {
      name: formValues.name,
      status: formValues.status ? 'COMPLETED' : 'UNCOMPLETED',
      dueAt: formValues.dueAt,
    })
      .then(this.props.updateGoal)
      .then(this.handleEditOff)
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  handleDelete = () => {
    const { goal } = this.props;

    return API.del(`goals/${goal._id}`)
      .then(this.props.deleteGoal)
      .then(() => {
        this.setState({ disabled: true });
      })
      .catch(catchFormErrors);
  };

  handleEditOn = () => {
    this.setState({ disabled: false }, () => {
      // Manually, ugly, focus on the fucking element. I can't believe
      // how much effort I spent to try do to it the redux-form / react 16 way
      // (difficult due to the fact the redux form has it's own Field component
      // which behave differently than a regular DOM element).
      // Fuck it. I'm doing it as simple as:
      document.getElementById(this.props.goal._id).focus();
    });
  };

  handleEditOff = () => {
    this.setState({ disabled: true });
  };

  handleFocus = (value) => {
    this.setState({
      shouldDisplayMenu: true,
    });
  };

  render() {
    const { form, initialValues, goal, isCurrentUser, t } = this.props;
    const { disabled, shouldDisplayMenu, shareMemoModalOpen } = this.state;

    return (
      <React.Fragment>
        <ReduxForm
          goal={goal}
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          onEdit={this.handleEditOn}
          onCancel={this.handleEditOff}
          onDelete={this.handleDelete}
          onFocus={this.handleFocus}
          onMemoAdd={this.handleShareMemoModalOpen}
          disabled={disabled}
          isCurrentUser={isCurrentUser}
          shouldDisplayMenu={shouldDisplayMenu}
          form={form}
        />

        <Modal
          isOpen={shareMemoModalOpen}
          onRequestClose={this.handleShareMemoModalClose}
          title={t('goal.memo.modalTitle')}
        >
          <Create
            goal={goal}
            type="GOAL"
            onSuccess={this.handleShareMemoModalClose}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  requestUserGoalMemos,
  updateGoal,
  deleteGoal,
};
export default connect(
  null,
  mapDispatchToProps
)(translate()(Edit));



// WEBPACK FOOTER //
// ./src/goals/edit/index.js